import * as queries from "../graphql_hasura/queries";
import axios from "axios";

function elanco_arr_to_obj(array) {
  var elanco_obj = {};
  for (const i in array) {
    elanco_obj[array[i].animal_id] = array[i];
  }
  return elanco_obj;
}

export const analytics_module = {
  namespaced: true,

  state: () => ({
    analytics: { human: [], betsy: [] },
  }),

  mutations: {
    set_analytics(state, payload) {
      state.analytics = payload;
    },
  },

  actions: {
    ddb_get_analytics({ rootGetters, commit }, params) {
      return new Promise((resolve) => {
        async function get_data(human) {
          var trial = [];
          const hasuraParams = rootGetters["auth/hasura_params"];
          const query_study = human ? params.study + "_human" : params.study;

          if (params.bin_size == "1d") { 
            let data = (
              await axios.post(
                hasuraParams.url,
                {
                  query: queries.scratching_summary_phase_total,
                  variables: {
                    where: {study: {_eq: query_study}},
                  },
                },
                {
                  headers: hasuraParams.headers,
                }
              )
            ).data;
            trial = data.data.scratching_summary_phase_total;
          } else {
            let used_query = 'scratching_summary_' + params.bin_size;
            
            for (const i in params.dates) {
              let data = (
                await axios.post(
                  hasuraParams.url,
                  {
                    query: queries[used_query],
                    variables: {
                      where: {study: {_eq: query_study}, phase: {_eq: params.dates[i]}},
                    },
                  },
                  {
                    headers: hasuraParams.headers,
                  }
                )
              ).data;
              trial[i] = elanco_arr_to_obj(data.data[used_query]);
            }
          }
          
          return trial;
        }

        async function get_all_data() {
          var betsy = [];
          var human = [];
          if (params.human_annotations) {
            betsy = await get_data(false);
            human = await get_data(true);
          } else {
            betsy = await get_data(false);
          }
          commit("set_analytics", { human: human, betsy: betsy });
          resolve();
        }
        get_all_data();
      });
    },
  },

  getters: {
    analytics: (state) => state.analytics,
  },
};
